export const getPiecesPercent = (stats)=>{
    
    let totalProducted = 0;
    let totalBad = 0;
    let totalForWork = 0;
    stats.forEach((stat) => {        
        totalProducted += stat.productedPieces
        totalBad += stat.badPieces
        totalForWork += parseInt(stat.forWork)
    })

    const productedPiecesPercent = parseInt(parseInt(totalProducted) / parseInt(totalForWork) * 100)
    const badPiecesPercent = parseInt(parseInt(totalBad) / parseInt(totalForWork) * 100)

    return { productedPiecesPercent, badPiecesPercent }
}